/**
 * What the terms of service tell search engines and link previews — ONE copy, read by today's page
 * (src/pages/Terms.tsx) and its rebuild in the new design (src/design/pavilion/pages/terms-of-service/), the way
 * src/config/aboutSeo.ts serves both about pages (PV5a, design record §7b lane A).
 *
 * THE SHAPE IS READ BY THE GUEST CHAT'S KNOWLEDGE SOURCE (scripts/generate-guest-knowledge-source.mjs lists this file
 * for "/terms-of-service"): its extractor takes a `title:` / `description:` field whose string sits on the same line,
 * so each stays one line.
 */

/** Where search files the terms of service, whichever address served them. */
export const TERMS_CANONICAL_URL = 'https://prest0.ai/terms-of-service';

/** The props both terms of service pages hand to <SeoHead>. */
export const TERMS_SEO = {
  title: 'Terms of Service: Your Agreement for Using Prest0n | prest0',
  // the tab says what search says (2026-11-03): the title without the site's name, which SeoHead adds back
  tabTitle: 'Terms of Service: Your Agreement for Using Prest0n',
  description: 'The terms that govern your use of prest0 and Prest0n, your full-time AI employee: accounts, plans and billing, acceptable use, data and liability.',
  keywords: 'prest0 terms of service, Prest0n terms, AI employee terms, prest0 agreement, plans and billing, acceptable use',
  canonicalUrl: TERMS_CANONICAL_URL,
  schemaType: 'WebPage',
} as const;
